interface IEmailManager {
  id: string;
  description: string;
  createdDate: Date;
  modifiedDate: Date;
  smtpServer: string;
  smtpPort: number;
  username: string;
  password: string;
  feedbackEmail: string;
  createdBy: string;
  modifiedBy: string;
}

export class EmailManagerModel implements IEmailManager {
  id: string = '';
  description: string = '';
  createdDate: Date = new Date();
  modifiedDate: Date = new Date();
  smtpServer: string = '';
  smtpPort: number = 0;
  username: string = '';
  password: string = '';
  feedbackEmail: string = '';
  createdBy: string = '';
  modifiedBy: string = '';

  constructor(props: Partial<IEmailManager> = {}) {
    Object.assign(this, props);
  }
}
